import React from 'react'
import { useTranslation } from 'react-i18next'
import moment from 'moment'
import AppModal from "components/ui/AppModal";

const PaymentLinkDetailModal = ({
  open,
  onClose=()=>{},
  modalInfo,
}) => {
  const { t } = useTranslation();
  const info = {
    "Payment Link": modalInfo?.paymentLinkUrl,
    // "Payment Gateway": modalInfo?.paymentGateway,
    "Payment Status": modalInfo?.paymentStatus,
    "Currency": modalInfo?.currency,
    "Purpose of Payment": modalInfo?.purposeOfPayment,
    "Cart Id": modalInfo?.cartId,
    "Created By": modalInfo?.createdBy,
    "Link Status": modalInfo?.linkStatus,
    "Link Creation Date": moment.unix(modalInfo?.linkCreationDate).format("DD/MM/YYYY"),
   
  }

  return (
    <AppModal
      open={open}
      maskClosable={false}
      onCancel={onClose}
      footer={null}
      title={t("Payment Link Details")}
    >
      <div className="grid grid-cols-3 gap-4">
        {Object.keys(info).map((key) => (
          <React.Fragment key={"payment-link-detail-" + key}>
           {info[key] ?  
           <>
           <p className="font-bold">{t(key)}</p>
            <p className="text-gray-600 col-span-2">{info[key]}</p>
            </> : null}
          </React.Fragment>
        ))}
      </div>
    </AppModal>
  )
}

export default PaymentLinkDetailModal